


















import { Vue, Component } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { getLangType } from '@/api/common'

@Component({
  name: 'SEOM'
})
export default class extends Vue {
    showNav = true
}
